import { Region } from '@lemon8/web-app-shared/i18n';
import { useTranslation } from 'react-i18next';

interface GiftConfigProps {
  image: string;
  ruleTitle: string;
  ruleAmount: string;
  description: string;
}

enum CouponType {
  Amazon = 1,
  TaoBin = 2,
  SevenEleven = 3,
  Shopee = 4,
}

export const useGiftConfig = (params: { giftType: string; region: Region; amountStr: string }): GiftConfigProps => {
  const { region, giftType, amountStr } = params;

  const { t } = useTranslation();

  const data: Record<string, GiftConfigProps> = {
    [CouponType.Amazon]: {
      image: '',
      ruleTitle: t('couponShare_reflow_howTo_header').replace(
        '{brand}',
        `<span>${t('couponShare_coupon_amazon')}</span>`,
      ),
      ruleAmount: t('couponShare_reflow_howTo_body_4')
        .replace('{brand}', t('couponShare_coupon_amazon'))
        .replace('{amount}', amountStr),
      description: t('couponShare_share')
        .replace('{brand}', t('couponShare_coupon_amazon'))
        .replace('{amount}', amountStr),
    },
    [CouponType.TaoBin]: {
      image: '',
      ruleTitle: t('couponShare_reflow_howTo_header').replace(
        '{brand}',
        `<span>${t('couponShare_coupon_TAOBIN')}</span>`,
      ),
      ruleAmount: t('couponShare_reflow_howTo_body_4')
        .replace('{brand}', t('couponShare_coupon_TAOBIN'))
        .replace('{amount}', amountStr),
      description: t('couponShare_share')
        .replace('{brand}', t('couponShare_coupon_TAOBIN'))
        .replace('{amount}', amountStr),
    },
    [CouponType.SevenEleven]: {
      image: '',
      ruleTitle: t('couponShare_reflow_howTo_header').replace('{brand}', `<span>${t('couponShare_coupon_711')}</span>`),
      ruleAmount: t('couponShare_reflow_howTo_body_4')
        .replace('{brand}', t('couponShare_coupon_711'))
        .replace('{amount}', amountStr),
      description: t('couponShare_share')
        .replace('{brand}', t('couponShare_coupon_711'))
        .replace('{amount}', amountStr),
    },
    [CouponType.Shopee]: {
      image: '',
      ruleTitle: t('couponShare_reflow_howTo_header').replace(
        '{brand}',
        `<span>${t('couponShare_coupon_Shopee')}</span>`,
      ),
      ruleAmount: t('couponShare_reflow_howTo_body_4')
        .replace('{brand}', t('couponShare_coupon_Shopee'))
        .replace('{amount}', amountStr),
      description: t('couponShare_share')
        .replace('{brand}', t('couponShare_coupon_Shopee'))
        .replace('{amount}', amountStr),
    },
  };

  const config = data[giftType];

  if (region === Region.jp) {
    // jp不能露出logo，采用特殊的图片
    config.image = '';
  }

  return config;
};
